export default {
      id: "ic-eye-close-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-eye-close-usage",
      toString: function () {
        return this.url;
      }
    }